import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import RequestTableModal from "components/ProjectSpecificComponents/Elements/Global/molecules/Modals/RequestTableModal"
import { observer } from "mobx-react"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import AdminPanelFormSection from "../../molecules/AdminPanelFormSection"
import RequestTableFormDefaultSortOrderSection from "../../molecules/Forms/RequestTableFormDefaultSortOrderSection"
import RequestTableForm from "../../molecules/Forms/RequestTableForm"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { useInView } from "react-intersection-observer"

interface Props {
	id?: string
}

const RequestTableFormSection = observer(({ id }: Props) => {
	const formStore = useFormStore()
	const { t } = useTranslation()
	const [isPreviewModalShown, setIsPreviewModalShown] = useState<boolean>(false)
	// If any table field is defind then shows default sort order
	const showDefaultSortOrder = formStore.selectedFormsConfig?.requestTable.some(
		(item) => item.mainFieldKey
	)

	const store = useStore()
	const { ref, inView } = useInView()
	useEffect(() => {
		store.setSectionIsInView({ section: "requestTableForm", inView })
	}, [inView])

	return (
		<>
			<div id={id} ref={ref}>
				<AdminPanelFormSection
				    language="requestTableLanguage"
					buttonsType="add-preview-delete"
					title={t("forms.header.requestTableForm")}
					tooltipText={t("forms.tooltip.requestTableForm")}
					onClickAddField={() => formStore.insertNewFieldIntoForm("requestTable")}
					onClickPreview={() => setIsPreviewModalShown(true)}
					onClickDeleteFields={() => formStore.resetMultiFieldForm("requestTable")}
				>
					<RequestTableForm />
					{showDefaultSortOrder && (
						<>
							<Whitespace x="2" />
							<RequestTableFormDefaultSortOrderSection />
						</>
					)}
				</AdminPanelFormSection>
			</div>

			{isPreviewModalShown && <RequestTableModal onClose={() => setIsPreviewModalShown(false)} />}
		</>
	)
})

export default RequestTableFormSection
